.dda-tooltip-container {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.dda-tooltip-box {
  position: absolute;
  visibility: hidden;
  background-color: var(--dda-neutral-100);
  border: solid 1px var(--dda-neutral-90);
  color: var(--dda-neutral-0);
  text-align: center;
  padding: 5px 12px;
  border-radius: 6px;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s;
}
.dda-tooltip-container:hover .dda-tooltip-box {
  visibility: visible;
  opacity: 1;
}
.dda-tooltip-box strong{
  font-size: 16px;
  color: var(--dda-neutral-0);
  white-space: nowrap;
}
.dda-tooltip-box p{
  font-size: 14px;
  color: var(--dda-neutral-variant-30);
  white-space: nowrap;
  margin: 0;
}

.dda-tooltip-box.top {
  bottom: 100%;
  left: 50%;
  transform: translate(-50%);
  margin-bottom: 7px;
}
.dda-tooltip-box.top::before, .dda-tooltip-box.top::after {
  content: "";
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  position: absolute;
  left: 50%;
  margin-inline-start: -10px;
}
.dda-tooltip-box.top::before {
  top: 100%;
  border-top: 8px solid var(--dda-neutral-90);
  margin-top: 0px;
}
.dda-tooltip-box.top::after {
  top: 100%;
  border-top: 8px solid var(--dda-neutral-100);
  margin-top: -2px;
  z-index: 1;
}


.dda-tooltip-box.bottom {
  top: 100%;
  left: 50%;
  transform: translate(-50%);
  margin-top: 7px;
}
.dda-tooltip-box.bottom::before, .dda-tooltip-box.bottom::after {
  content: "";
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  position: absolute;
  left: 50%;
  margin-inline-start: -10px;
}
.dda-tooltip-box.bottom::before {
  bottom: 100%;
  border-bottom: 8px solid var(--dda-neutral-90);
  margin-bottom: 0px;
}
.dda-tooltip-box.bottom::after {
  bottom: 100%;
  border-bottom: 8px solid var(--dda-neutral-100);
  margin-bottom: -2px;
  z-index: 1;
}

.dda-tooltip-box.left {
  top: 50%;
  right: 100%;
  margin-inline-end: 13px;
  transform: translate(0%, -50%);
}
.dda-tooltip-box.left::before, .dda-tooltip-box.left::after,
.dda-tooltip-box.right::before, .dda-tooltip-box.right::after {
  content: "";
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
}
.dda-tooltip-box.left::before {
  bottom: 100%;
  border-left: 8px solid var(--dda-neutral-90);
  right: -9px;
}
.dda-tooltip-box.left::after {
  bottom: 100%;
  border-left: 8px solid var(--dda-neutral-100);
  z-index: 1;
  right: -8px;
}

.dda-tooltip-box.right {
  top: 50%;
  left: 100%;
  margin-inline-start: 13px;
  transform: translate(0%, -50%);
}
.dda-tooltip-box.right::before {
  bottom: 100%;
  border-right: 8px solid var(--dda-neutral-90);
  left: -9px;
}
.dda-tooltip-box.right::after {
  bottom: 100%;
  border-right: 8px solid var(--dda-neutral-100);
  z-index: 1;
  left: -8px;
}